module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"report_button":"신고 및 차단"}}')
  delete Component.options._Ctor
}
